
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import SujetForm from '@/components/forms/MailSujetForm.vue'

const mailModule = namespace('mail')

@Component({
  components: {
    BaseCardContainer,
    SujetForm
  }
})
export default class SujetCreate extends Vue {
  @mailModule.Action('createMailSujetAction') createMailSujet: any
  @mailModule.Action('getMailSujetsAction') getMailSujets: any

  mounted() {
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.createMailSujet(data).then(async (data: any) => {
      this.getMailSujets()
      this.$router.push({name: 'SujetList'})
    })
  }

  onCancel() {
    this.$router.replace({name: 'SujetList'})
  }
}
